// Vendors
import React from 'react';
import { createRoot } from 'react-dom/client';
// Entrypoint
import Entrypoint from 'entrypoint/entrypoint';
import { redirectToBasePath, startsWithBasePath, isONBPath } from './utils/boostrap.common.utils';

const BootstrapCommon = (): any => {
  if (!startsWithBasePath() && !isONBPath()) {
    redirectToBasePath();
    return;
  }

  createRoot(document.getElementById('root') as HTMLElement).render(<Entrypoint />);
};

export default BootstrapCommon;
